import { TabViewModel, IdentifyTabData } from '../../models/common/tab-view.model';

export interface ITabViewState {
    tabViews: Array<TabViewModel>,
    activeTab: TabViewModel;
    oldTab: TabViewModel;
}

export interface AddTabParamModel {
    setActive: boolean;
    tab: TabViewModel;
}

export interface SetUnsavedDataParamModel {
    identifyData: IdentifyTabData;
    value: boolean;
    confirmActions?: Array<string>;
}

export interface UpdateTabIdParamModel {
    identifyData: IdentifyTabData;
    newId: string | number
}

export const TAB_VIEW_MUNTATIONS = {
    ADD_TAB: 'addTab',
    REMOVE_TAB: 'removeTab',
    SET_UNSAVED_DATA: 'setUnsavedData',
    SET_TAB_VIEWS: 'setTabViews',
    ADD_QUERY_STRING_TAB_VIEW: 'addQueryStringTabView',
    SET_CALLBACK_CLOSE_TAB_VIEW: 'setCallbackCloseTabView',
    SET_CALLBACK_CLEAR_MEMORY: 'setCallbackClearMemory',
    UPDATE_TAB_IDENTIFY_ID: 'updateTabIdentifyId',
    UPDATE_TAB_TITLE: 'updateTabTitle',
    UPDATE_TABVIEW_ORDER: 'updateTabViewOrder',
    UPDATE_TABVIEW_QUERY: 'updateTabViewQuery',
    UPDATE_OLD_TAB: 'updateOldTab'
}

export const TAB_VIEW_ACTIONS = {
    ADD_TAB: 'addTab',
    REMOVE_TAB: 'removeTab',
    SET_UNSAVED_DATA_STATE: 'setUnsavedDataState',
    SET_TAB_VIEWS: 'setTabViews',
    ADD_QUERY_STRING_TAB_VIEW: 'addQueryStringTabView',
    SET_CALLBACK_CLOSE_TAB_VIEW: 'setCallbackCloseTabView',
    SET_CALLBACK_CLEAR_MEMORY: 'setCallbackClearMemory',
    UPDATE_TAB_IDENTIFY_ID: 'updateTabIdentifyId',
    UPDATE_TAB_TITLE: 'updateTabTitle',
    UPDATE_TABVIEW_ORDER: 'updateTabViewOrder',
    UPDATE_OLD_TAB: 'updateOldTab'
}

export const TAB_VIEW_GETTERS = {
    GET_TAB_VIEWS: 'getTabViews',
    ACTIVE_TAB: 'activeTab',
    ACTIVE_TAB_PATH: 'activeTabPath',
    OLD_TAB: 'oldTab'
}